import FilterModal from './FilterModal'

export default FilterModal



// WEBPACK FOOTER //
// ./src/modules/Filters/FilterModal/index.js